var React = require('react');

function TrendArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":">","d":"M81 46H60.2428L36.9884 10.7467H44.1676L20.9133 46H0L30.5896 0L50.5665 0L81 46Z","fill":"#218986"}));
}

TrendArrow.defaultProps = {"width":"81","height":"46","viewBox":"0 0 81 46","fill":"none"};

module.exports = TrendArrow;

TrendArrow.default = TrendArrow;
